import { FormControl, TextField, Grid, InputAdornment } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const FormNameDesc = ({ formValues, formErrors, onFormChange }) => {
	const { t } = useTranslation();
	const [values, setValues] = useState({
		name: formValues.name,
		description: formValues.description,
	});

	const [charCount, setCharCount] = useState({
		name: formValues.name.length,
		description: formValues.description.length,
	});

	useEffect(() => {
		setValues({
			name: formValues.name,
			description: formValues.description,
		});
		setCharCount({
			name: formValues.name.length,
			description: formValues.description.length,
		});
	}, [formValues]);

	const handleChange = (e) => {
		const { id, value } = e.target;
		setValues((prevValues) => ({
			...prevValues,
			[id]: value,
		}));
		setCharCount((prevCount) => ({
			...prevCount,
			[id]: value.length,
		}));
		onFormChange(id, value);
	};

	return (
		<FormControl fullWidth>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TextField
						fullWidth
						required
						id="name"
						label={t("sim.sim_name")}
						variant="outlined"
						value={values.name}
						onChange={handleChange}
						error={formErrors.name}
						helperText={formErrors.name ? t("aux.messages.campo_obligatorio") : ""}
						inputProps={{ maxLength: 50 }}
						InputProps={{
							endAdornment: <InputAdornment position="end">{charCount.name}/50</InputAdornment>,
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						fullWidth
						required
						id="description"
						label={t("aux.description")}
						variant="outlined"
						multiline
						value={values.description}
						onChange={handleChange}
						error={formErrors.description}
						helperText={formErrors.description ? t("aux.messages.campo_obligatorio") : ""}
						inputProps={{ maxLength: 250 }}
						InputProps={{
							endAdornment: <InputAdornment position="end">{charCount.description}/250</InputAdornment>,
						}}
					/>
				</Grid>
			</Grid>
		</FormControl>
	);
};
